import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Breadcrumbs, Table } from "../components";
import { useAgent } from "../hooks";

function LeadsPage() {
  const tableColumns = [
    { id: "full_name", name: "Full Name" },
    { id: "mobile", name: "Contact number" },
    { id: "email", name: "Email Address" },
    { id: "project_name", name: "Interested project name" },
    { id: "agent_name", name: "Agent" },
  ];

  const [leads, setLeads] = useState([]);
  const { fetchAllLeads } = useAgent();

  useEffect(() => {
    const fetchLeads = async () => {
      const { leads, error } = await fetchAllLeads();
      if (error) return toast.error(error);
      setLeads(leads);
    };
    fetchLeads();
  }, []);

  return (
    <>
      <Breadcrumbs />
      <Table columns={tableColumns} data={leads} title="Leads" isFullLength={true} />
    </>
  );
}

export default LeadsPage;
